import { DEPARTMENT_PROVIDE_OPTIONS, type RegistrationExtendedFormValues } from "@buxus/shared";

type Props = {
  extendedForm: RegistrationExtendedFormValues;
  onPatch: (partial: Partial<RegistrationExtendedFormValues>) => void;
};

export function AgencyCapabilitiesStep({ extendedForm, onPatch }: Props) {
  const sortedProvideOptions = [...DEPARTMENT_PROVIDE_OPTIONS].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" }),
  );

  const toggleProvide = (value: string) => {
    const current = extendedForm.canYourDepartmentProvide;
    const next = current.includes(value) ? current.filter((x) => x !== value) : [...current, value];
    onPatch({ canYourDepartmentProvide: next });
  };

  return (
    <>
      <h2 className="reg-step-title">Agency Capabilities</h2>

      <p className="reg-step-lead">Department can provide or assist with:</p>
      <div className="reg-checkbox-stack">
        {sortedProvideOptions.map((option) => (
          <label key={option} className="reg-checkbox-label">
            <input
              type="checkbox"
              checked={extendedForm.canYourDepartmentProvide.includes(option)}
              onChange={() => toggleProvide(option)}
            />
            <span>{option}</span>
          </label>
        ))}
      </div>
    </>
  );
}
